/**
 * Tab and action icons drawn with the same 1.75 stroke as the 128 catalogue
 * illustrations. They replace the old text glyphs (⌂◫＋▦◒).
 */
export type IconName =
	| "report"
	| "home"
	| "records"
	| "capture"
	| "household"
	| "dogam"
	| "help"
	| "calendar"
	| "list"
	| "share";

const PATHS: Record<IconName, string> = {
	report: "M5 19V11M12 19V5M19 19v-6",
	home: "M4 11.5 12 5l8 6.5V20h-5.5v-5h-5v5H4z",
	records:
		"M6 3.5h12v17l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4-2 1.4zM9 8h6M9 11.5h6M9 15h3.5",
	capture: "M12 5v14M5 12h14",
	household:
		"M4 8h16l-1.6 11.2a1.6 1.6 0 0 1-1.6 1.3H7.2a1.6 1.6 0 0 1-1.6-1.3zM8.5 8V6.5a3.5 3.5 0 0 1 7 0V8",
	dogam: "M4.5 4.5h6v6h-6zM13.5 4.5h6v6h-6zM4.5 13.5h6v6h-6zM13.5 13.5h6v6h-6z",
	help: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.6 9.4a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .8-1 1.5v.6M12 16.8v.2",
	calendar:
		"M4.5 6.5h15v13h-15zM4.5 10.5h15M8.5 4v4M15.5 4v4M8 14h2M12 14h2M16 14h.5M8 17h2M12 17h2",
	list: "M9 7h11M9 12h11M9 17h11M4.5 7h.5M4.5 12h.5M4.5 17h.5",
	share:
		"M12 4v11M7.5 8.5 12 4l4.5 4.5M5 13v5.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V13",
};

export function Icon({
	name,
	size = 22,
	label,
}: {
	name: IconName;
	size?: number;
	label?: string;
}) {
	return (
		<svg
			className={`icon icon-${name}`}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={1.75}
			strokeLinecap="round"
			strokeLinejoin="round"
			role={label ? "img" : undefined}
			aria-label={label}
			aria-hidden={label ? undefined : true}
			focusable="false"
		>
			<path d={PATHS[name]} />
		</svg>
	);
}
